import React from 'react';
import './pair-success.scss';

function PairSuccess() {
  return (
    <div
      className="success"
      style={{
        height: window.innerWidth <= window.innerHeight ? '79%' : '88%',
      }}
    >
      <div
        className="success__msg"
        style={{
          margin: window.innerWidth <= window.innerHeight ? '100px auto 0' : '40px auto 0',
          height: window.innerWidth <= window.innerHeight ? '100px' : '75px',
          width: window.innerWidth <= window.innerHeight ? '70%' : '50%',
        }}
      >
        {' '}
        <img
          src="assets/img/done.svg"
          style={{
            height: window.innerWidth > window.innerHeight && '2rem',
          }}
          alt=""
        />{' '}
        <p
          className="success__msg__text"
          style={{
            fontSize: window.innerWidth <= window.innerHeight ? ' 2.4rem' : '2rem',
          }}
        >
          Display Paired
        </p>
      </div>

      <img
        className="success__image"
        src="assets/img/pair-success.png"
        alt=""
        style={{
          margin: window.innerWidth <= window.innerHeight ? '60px auto' : '0px auto',
          height: window.innerWidth > window.innerHeight && '76%',
        }}
      />
    </div>
  );
}

export default PairSuccess;
